let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cOqwO")).then(() => parcelRequire('6U26G'));